import { render, staticRenderFns } from "./mortgage-purchase-rate-table-tabbed.vue?vue&type=template&id=b6f6d2f4"
import script from "./mortgage-purchase-rate-table-tabbed.vue?vue&type=script&lang=js"
export * from "./mortgage-purchase-rate-table-tabbed.vue?vue&type=script&lang=js"
import style0 from "./mortgage-purchase-rate-table-tabbed.vue?vue&type=style&index=0&id=b6f6d2f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports